module.exports = __webpack_public_path__ + "static/media/copernicus.86ecbf6c.svg";